import * as FullStory from '@fullstory/browser';

const ORG_ID = process.env.REACT_APP_FULLSTORY_ORG_ID;

export default function initializeFullStory() {
  console.log('FS.INIT', { ORG_ID });
  if (ORG_ID) {
    FullStory.init({
      orgId: ORG_ID,
    });
  }
}

export function setUserDataVars(displayName: string, email: string) {
  try {
    FullStory.setUserVars({
      displayName,
      email,
    });
  } catch (e) {
    console.log('FS.ERROR', e);
  }
}
